import React from 'react';
import useReveal from '../hooks/useReveal';
import PageBanner from '../Components/PageBanner';
import Services from '../Components/Services';

const ServicesPage = () => {
    useReveal();

    return (
        <div>
            <PageBanner
                title="Services"
                text="Glazing, cladding, doors, windows, railing, clean rooms, canopies and skylights."
                image="/projects/11/2.jpeg"
            />
            <Services />
        </div>
    );
};

export default ServicesPage;
